// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__qafOT","upload":"Small_upload__2_Hcs","imageWrap":"Small_imageWrap__M14yL","removeBtn":"Small_removeBtn__6EvTM"};